<div class="d-none sideBar__ resizable" id="processWrap" resizable>
  <div class="grabber" grabber>
    <i class="pi pi-chevron-left f-12"></i>
  </div>
  <div class="scrol_">
    <div id="workflow-process" class="expanded">
      <ng-scrollbar class="vertical-scrollbar" track="vertical" visibility="hover" appearance="compact">
        <div class="field-area">
          <div class="d-flex justify-content-between align-items-center form-group">
            <p class="f-14">
              Processes <span *ngIf="processModule != ''">- {{ processModule }}</span>
            </p>
            <div class="btnCloseFlow">
              <i class="fa fa-times f-18" aria-hidden="true" (click)="closePane()"></i>
            </div>
          </div>
          <div class="position-relative mt-3 mb-4">
            <i class="pi pi-search search-Icon"></i>
            <input type="text" (input)="FilterSearchProcessList($event.target.value)" placeholder="Search Process" class="search-Input" />
          </div>
          <!-- <div class="w-100 h-100 d-flex align-items-center justify-content-center py-5 my-5" *ngIf="isLoading">
            <img [src]="common_images?.loading_state_gif" alt="" width="30px" />
          </div> -->
          <div id="blockList" class="overflow-x-hidden" *ngIf="!isLoading">
            <div class="position-relative">
              <div class="scroll_landing_page" (scroll)="onScroll($event)" #scrollableElement>
                <i class="pi pi-arrow-up" (click)="scrollToTop()" *ngIf="scrollTop > 50"></i>
                <ng-container *ngIf="ProcessList?.length > 0">
                  <!-- ?.slice(first, (first + numberOfRecords)) -->
                  <div *ngFor="let process of ProcessList?.slice(0, rows); let i = index" class="blockElement noSelect w-auto">
                    <div class="blockIn ml-0 no-wrap-block align-items-center">
                      <div class="blockIcon cursor-pointer" (click)="ChangeProcessStatus(process)">
                        <img [src]="common_images?.play_icon" width="24" height="24" *ngIf="process?.process === 'play'" />
                        <img [src]="images?.pause_icon_v2" width="24" height="24" *ngIf="process?.process === 'pause'" />
                        <img [src]="common_images?.pause_icon" width="24" height="24" *ngIf="process?.process === 'stop'" />
                      </div>
                      <div class="blockText_process">
                        <div>
                          <p class="blockTitle mb-1">{{ process?.name }}</p>
                          <p-badge *ngIf="process?.module" [value]="process?.module" styleClass="mr-2 ml-auto rounded"></p-badge>
                        </div>
                        <ng-container *ngIf="process?.name?.toLowerCase() !== 'all'">
                          <img [src]="images?.progress_icon" width="30" height="30" class="cursor-pointer" (click)="getWorkFlowHistory(process)" />
                          <p
                            class="process-count cursor-pointer"
                            [ngStyle]="{ right: process?.process_running_count?.toString()?.length > 1 ? '8px' : '12px' }"
                            (click)="getWorkFlowHistory(process)">
                            {{ process?.process_running_count }}
                          </p>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
  </div>
</div>

<p-dialog
  header="Workflow History"
  [showHeader]="true"
  [(visible)]="process_history"
  [draggable]="false"
  [style]="{ width: '50vw' }"
  [modal]="true"
  [baseZIndex]="100000">
  <div>
    <ng-container *ngIf="workflow_history?.length > 0; else no_history">
      <p-table [value]="workflow_history">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Status</th>
            <th>Created</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-process_history>
          <tr class="cursor-pointer">
            <td>{{ '' }}</td>
            <td>{{ process_history?.status }}</td>
            <td>{{ process_history.created_at | customTimeAgo }}</td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
    <ng-template #no_history>
      <p>No record found</p>
    </ng-template>
  </div>
</p-dialog>
